module.exports = __webpack_public_path__ + "static/img/2.29b53ed6.png";